import React from 'react';
import { Link } from 'react-router-dom';
import siteContent from '../../content/site/content.json';
import { Button } from '../ui/button';
import { CheckCircle, ArrowRight, Handshake } from 'lucide-react';

const PilotInviteSection = () => {
  const d = siteContent.pilotInvite;
  if (!d) return null;

  return (
    <section id="pilot-invite" className="py-16 lg:py-24 bg-[#1F1E1E] scroll-mt-20" data-testid="pilot-invite-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center gap-2 bg-white/10 px-4 py-2 rounded-full mb-6">
          <Handshake className="w-4 h-4 text-[#D4722F]" />
          <span className="text-sm font-semibold text-[#D4722F]">Early access is open</span>
        </div>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight mb-5">
          {d.heading}
        </h2>
        <p className="text-base md:text-lg text-white/70 leading-relaxed max-w-2xl mx-auto mb-8">
          {d.description}
        </p>

        <div className="flex flex-wrap justify-center gap-3 mb-9">
          {(d.reassurance || []).map((point, i) => (
            <div key={i} className="inline-flex items-center gap-2 bg-white/5 border border-white/10 rounded-full px-4 py-2" data-testid={`pilot-invite-point-${i}`}>
              <CheckCircle className="w-4 h-4 text-[#D4722F]" />
              <span className="text-sm text-white/85">{point}</span>
            </div>
          ))}
        </div>

        <Button
          asChild
          data-testid="pilot-invite-cta"
          className="bg-[#B5541B] hover:bg-[#8B3F14] text-white font-semibold h-auto px-8 py-6 text-base rounded-full shadow-lg hover:shadow-xl transition-all duration-300 group"
        >
          <Link to="/resident-pilot">
            {d.ctaLabel}
            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </Link>
        </Button>

        <p className="mt-5 text-xs text-white/50" data-testid="pilot-invite-note">{d.note}</p>

        <p className="mt-8 pt-6 border-t border-white/10 text-sm text-white/60" data-testid="pilot-invite-provider-line">
          Not ready yet?{' '}
          <Link to="/updates" data-testid="pilot-invite-updates-link" className="font-semibold text-white/80 hover:text-white underline underline-offset-4 decoration-white/30 transition-colors">
            Get launch updates
          </Link>
          <span className="mx-3 text-white/25">|</span>
          Looking after homes or residents?{' '}
          <Link to="/providers#pilot-form" data-testid="pilot-invite-provider-link" className="font-semibold text-[#D4722F] hover:text-white transition-colors">
            Start a provider pilot →
          </Link>
        </p>
      </div>
    </section>
  );
};

export default PilotInviteSection;
